import {theme} from '@styles/theme';
import styled from 'styled-components';

export const AccordionWrapper = styled.div<{
  contentWidth: string | undefined;
  marginLeft: string | undefined;
}>`
  width: ${({contentWidth}) => (contentWidth ? contentWidth : 'calc(100% + 48px)')};
  margin-left: ${({contentWidth, marginLeft}) =>
    marginLeft ? marginLeft : contentWidth ? '0px' : '-24px'};
  position: relative;
  -webkit-tap-highlight-color: transparent;
`;

export const AccordionTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  position: relative;
  padding: 16px 0;
  cursor: pointer;
  background-color: ${theme.colors.basic07};
  border: 1px solid ${theme.colors.basic06};
  & * {
    cursor: pointer;
  }
`;

export const AccordionContent = styled.div<{
  isOpen: boolean;
}>`
  position: ${({isOpen}) => (isOpen ? 'static' : 'absolute')};
  height: fit-content;
  max-height: ${({isOpen}: {isOpen: boolean}) => (isOpen ? '99999px' : '0')};
  opacity: ${({isOpen}: {isOpen: boolean}) => (isOpen ? '1' : '0')};
  transform: ${({isOpen}: {isOpen: boolean}) => (isOpen ? 'scale(1)' : 'scale(0)')};
  transition:
    opacity 1.25s ease,
    max-height 0.25s ease-in;
`;
